export const translationEngDefault = {
  SkhemataBlogPost: {
    backToBlog: 'Back to Blog',
    tags: 'Tags',
    categories: 'Categories',
  }
};
